import { Close } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { MasterContext, MobiOrNotContext, UserContext } from "../ContextApi/context";
import PopUpMsg from "../DTechComp/PopUpMsg";
import PopUpRegular from "../DTechComp/PopUpRegular";
import utilsCodes from "../_Utils/utilsCodes";
import myFunctions from "../myFunctions";
import PopUpPhoneCheckCode from "../DTechComp/PopUpPhoneCheckCode";
import TopBigSlides from "../DTechComp/TopBigSlides";
import { Helmet } from "react-helmet";
import ConnUrls from "../Connections/ConnectURL";
import "../DTechComp/Pops_Secials/WelcomeScreen/WelcomeScreen.css";


const UserDetails = (props) => {


    const [master, setMaster] = useContext(MasterContext);
    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState(props.initPhone || "");
    const [password, setPassword] = useState("");
    const [connectGO, setConnectGO] = useState(true);


    const [readIt, setReadIt] = useState(false);
    const [thePopUp, setThePopUp] = useState("");


    const history = useHistory();
    // const [topSlides, setTopSlides] = useState();

    const [theErrors, setTheErrors] = useState("");
    const [errorsTxts, setErrorsTxts] = useState("");


    let jumcodeChek = 0;
    let tryLoop = -1;

    useEffect(() => {

        props.scrollToTop();
        props.shoTopStrp(false)
        // getToPSldData();
    }, [])

    const saveUser = () => {

        let stopMe = false;
        let thEr = "";
        let errs = [];
        if (firstName.trim().length <= 1) {
            thEr = "firstName";
        }
        if (lastName.trim().length <= 1) {
            thEr += ",lastName";
        }
        if (!validPhone()) {
            thEr += ",phone";
            errs = (errs == "") ? "יש להזין מספר טלפון תקין" : errs;

        }
        if (!validEmail()) {
            thEr += ",email";
            errs = (errs == "") ? "יש להזין כתובת מייל חוקית" : errs;
        }
        // if (!validPassword()) {
        //     thEr += ",password";
        //     errs = (errs == "") ? "יש להזין סיסמא חזקה יותר.\n על הסיסמא להכיל מינמום 6 תווים, אות גדולה באנגלית, אות קטנה באנגלית ותו מיוחד ( לדוגמא: ! או $) " : errs;
        // }
        if (!readIt) {
            thEr += ",readIt";
            errs = (errs == "") ? "יש לאשר את קריאת התקנון" : errs;
        }

        if (thEr == "") {
            createUserApply();
        }

        setTheErrors(thEr)
        setErrorsTxts(errs)

    }

    const createUserApply = async () => {
        tryLoop++;

        let newUsr = { firstName, lastName, phone, email, password, readIt, tryLoop }
        let codeReply = await utilsCodes.createCodeNuser(newUsr);

        if (codeReply.errormsg != null) {

            if (codeReply.errormsg.includes("מספר הטלפון המוזן כבר קיים במערכת")) {
                setConnectGO(true)
            }
            else { setConnectGO(false) }
            setErrorsTxts(codeReply.errormsg);
            setThePopUp();
            if (codeReply.loopUp == true) setPhone("");


        }
        else {

            setThePopUp(
                <PopUpPhoneCheckCode key={Date.now()} Title={["אימות פרטים"]}
                    cssStyl={`onTopOfAll`}
                    topTitle={"הרשמה"}
                    topDodo={master.codeSMSImg}
                    placeholdTxtF="קוד לבדיקה"
                    ContentText={[`שלחנו קוד ב-SMS למספר ${phone}`]}
                    inLabel={""}
                    okClick={(codeCheck) => checkForCode(codeCheck, codeReply.nId)}
                    cancelClick={() => setThePopUp()}
                    recreateCode={() => createUserApply()}
                    errorMsg={""}
                />
            )
        }
    }

    const checkForCode = async (codeCheck, nId) => {
        let newUsr = { firstName, lastName, phone, email, password, readIt, tryLoop }
        let codeReply = await utilsCodes.checkCode(nId, { codeCheck, newUsr });

        if (codeReply.errMsg !== "Created") {
            // key חדש - החלון נבנה מחדש ומציג את השגיאה (showError)
            setThePopUp(
                <PopUpPhoneCheckCode key={Date.now()} Title={["אימות פרטים"]}
                    cssStyl={`onTopOfAll`}
                    topTitle={"הרשמה"}
                    topDodo={master.codeSMSImg}
                    placeholdTxtF="קוד לבדיקה"
                    ContentText={[`שלחנו קוד ב-SMS למספר ${phone}`]}
                    inLabel={""}
                    okClick={(codeCheck) => checkForCode(codeCheck, nId)}
                    cancelClick={() => setThePopUp()}
                    recreateCode={() => createUserApply()}
                    showError={true}
                    errorMsg={codeReply.errMsg}
                />
            )
        }
        else {
            localStorage.setItem("usrtoken", codeReply.token);

            let bk = await myFunctions.connCheck();
            if (bk != null) {

                setUser(bk.user);

            }
            else {

                let user = {
                    firstName: "",
                    lastName: "",
                    email: "",
                    rest: "",
                }
                setUser(user)
            }

            // בתוך זרימת ההתחברות - חלון האישור של ההתחברות ("היי ..."), במקום ההרשמה
            if (props.onRegistered) {
                setThePopUp();
                props.onRegistered({ firstName });
                return;
            }

            setThePopUp(
                <PopUpMsg key={jumcodeChek} Title={["ברוכים הבאים"]}
                    nosnippet={true}
                    cssStyl={"okPOP onTopOfAll"}
                    topSlides={<TopBigSlides TopImages={[{ img: master.welcomeImg, txt: "" }]} />}
                    ContentText={[`היי ${firstName}`, "אנחנו ממש שמחים שהצטרפת אלינו!"]}
                    inLabel={""}
                    okClick={() => goToBack()}
                    btn1Css={"btnYellow1 btnPoppadding15"}
                    errorMsg={""} />

            );

            // setUser(codeReply);


        }
    }

    const validPhone = () => {
        if (phone !== "") {
            var clearPhone = phone.replace(/-/g, '');
            var pattern = /^[0-9]+$/;
            if (!pattern.test(clearPhone)) {
                return false;
            }
            // Check if starts with '0'
            if (clearPhone[0] !== '0') {
                return false;
            }
            // Length must be 10 or 9 digits
            if (clearPhone.length !== 10 && clearPhone.length !== 9) {
                return false;
            }
            return true;
        }
    }
    const validEmail = () => {
        if (email !== "") {
            var pattern = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
            if (!pattern.test(email)) {
                return false
            }
            else {
                return true;
            }
        }
    }

    const validPassword = () => {
        if (password !== "") {
            let pattern = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{6,}))');
            if (!pattern.test(password)) {
                return false
            }
            else {
                return true;
            }
        }
    }
    const goToBack = async () => {
        setThePopUp();
        try {
            props.closeMeFuc();
        }
        catch { }

        // let bkPage = sessionStorage.getItem('bkPage');

        await UserEffectFunction();
        // if (bkPage && bkPage != "") {

        //     history.push(bkPage);
        // }
        // else {
        //     history.push('/');
        // }


        // if (props.backFunc) {
        //     props.closeMeFuc();
        // }
        // else {
        //     history.push("/");
        // }
    }

    // בתוך זרימת ההתחברות - חזרה לחלון הפתיחה. אחרת סוגר הכל
    const backBtn = () => {
        if (props.onBack) props.onBack();
        else goToBack();
    }

    myFunctions.useEscapeKey(backBtn);

    // Back במובייל - כמו X: חזרה לחלון הפתיחה (רק בתוך זרימת ההתחברות)
    myFunctions.useBackClose(props.onBack);

    const kbOpen = myFunctions.useKeyboardOpen();

    const fieldCss = (key) => `ws-input ws-input-start${theErrors.includes(key) ? " ws-input-err" : ""}`;

    return (
        <div className={"loginPage"}>
            <div className="ws-backdrop" dir="rtl">
                <div className={`ws-card${kbOpen ? " ws-kb" : ""}`}>
                    <div className="ws-header" dir="rtl">
                        <button type="button" className="btnReset ws-Close-btn onRight" aria-label="חזור" onClick={() => backBtn()}>
                            <Close aria-hidden="true" style={{ width: '100%', height: '100%' }} />
                        </button>
                        <h1 className="arrowing fullRow ws-header-label noMargin">הרשמה</h1>
                    </div>

                    <h2 className={"bold ws-title arrowing"}>הפרטים שלך</h2>
                    <div className={"ws-desc ws-promo arrowing"}>כמה פרטים, ואפשר להזמין. פשוט, מהיר, והכי משתלם בסביבה.</div>

                    {
                        (theErrors != "") ?
                            <div id="userDetailsFormError" className="ws-errBox" role="alert">
                                {(!theErrors.includes("firstName") &&
                                    !theErrors.includes("lastName") &&
                                    errorsTxts != "") ?
                                    errorsTxts : "כל השדות המסומנים הם חובה"}
                            </div>
                            : (errorsTxts != "") ?
                                <div id="userDetailsFormError" className="ws-errBox" role="alert">
                                    {errorsTxts}
                                    {(connectGO) ?
                                        <button type="button" className="btnReset ws-link ws-errLink" onClick={() => props.connectWithNumber()}>התחברות עם המספר</button> : ""}
                                </div> : ""
                    }

                    <div className="ws-fields">
                        <label className="sr-only" htmlFor="userDetFirstName">שם פרטי</label>
                        <input id="userDetFirstName" type={"text"} className={fieldCss("firstName")} value={firstName} placeholder={"שם פרטי"}
                            onChange={(e) => setFirstName(e.target.value)}
                            onFocus={myFunctions.scrollFieldIntoView}
                            aria-required="true" aria-invalid={theErrors.includes("firstName")} aria-describedby="userDetailsFormError"
                            autoComplete="given-name" />

                        <label className="sr-only" htmlFor="userDetLastName">שם משפחה</label>
                        <input id="userDetLastName" type={"text"} className={fieldCss("lastName")} value={lastName} placeholder={"שם משפחה"}
                            onChange={(e) => setLastName(e.target.value)}
                            onFocus={myFunctions.scrollFieldIntoView}
                            aria-required="true" aria-invalid={theErrors.includes("lastName")} aria-describedby="userDetailsFormError"
                            autoComplete="family-name" />

                        <label className="sr-only" htmlFor="userDetPhone">טלפון נייד (לקבלת SMS)</label>
                        <input id="userDetPhone" type={"tel"} inputMode="numeric" className={fieldCss("phone")} value={phone} placeholder={"טלפון נייד (לקבלת קוד)"}
                            onChange={(e) => setPhone(e.target.value)}
                            onFocus={myFunctions.scrollFieldIntoView}
                            aria-required="true" aria-invalid={theErrors.includes("phone")} aria-describedby="userDetailsFormError"
                            autoComplete="tel" />

                        <label className="sr-only" htmlFor="userDetEmail">אימייל</label>
                        <input id="userDetEmail" type={"email"} className={fieldCss("email")} value={email} placeholder={"אימייל"}
                            onChange={(e) => setEmail(e.target.value)}
                            onFocus={myFunctions.scrollFieldIntoView}
                            aria-required="true" aria-invalid={theErrors.includes("email")} aria-describedby="userDetailsFormError"
                            autoComplete="email" />
                    </div>

                    <div className={`ws-chkRow${theErrors.includes("readIt") ? " ws-chkRow-err" : ""}`}>
                        <Checkbox checked={readIt} onChange={() => setReadIt(readIt ? false : true)} className="ws-chk"
                            inputProps={{ 'aria-labelledby': 'userDetReadItTxt', 'aria-required': 'true' }} />
                        <div id="userDetReadItTxt"><span>קראתי ואני מסכים/ה </span><Link className={"ws-link"} to={"/TAkanon"}>לתקנון</Link></div>
                    </div>

                    <button type="button" className={"ws-btn ws-btn-primary"} onClick={() => saveUser()}>הרשמה</button>

                    {props.connectWithNumber &&
                        <div className="ws-newUser">
                            כבר רשומים?{" "}
                            <button type="button" className="btnReset ws-link" onClick={() => props.connectWithNumber()}>להתחברות</button>
                        </div>
                    }
                </div>
            </div>
            {thePopUp}
            <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/UserDetails`
                    }
                ]}>
                <link rel="canonical" href={`${ConnUrls.siteDomainNam}/UserDetails`} />
            </Helmet>
        </div >
    )

}

export default UserDetails